export enum RoutesEnum {
  homeScreen = '/',
  shopScreen = '/sklep',
  promoScreen = '/promo',
  promo2i3Screen = '/promo2i3',
  infoScreen = '/informacje',
  searchScreen = '/szukaj',
  productScreen = '/produkt',
  welcomeScreen = '/powitanie',
  confirmOrderScreen = '/confirm',
  logo = '/logo-1671803795.jpg',
}
